module.exports = __webpack_public_path__ + "static/img/3_6.41188c78.jpg";